// extracted by mini-css-extract-plugin
module.exports = {"CartItem":"CartItem_CartItem__jLPfk","Summary":"CartItem_Summary__dinBP","Price":"CartItem_Price__1hI6K","Amount":"CartItem_Amount__1s3R3","Actions":"CartItem_Actions__16JrY"};